import { Alert, Card, Group, Stack, Switch, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { ApiErrorAlert } from "../components/ApiErrorAlert.js";
import { hasRole, useCurrentUser } from "../hooks/useAuth.js";
import {
  useMailEinstellungen,
  useSetzeAbmeldenErlaubt,
  useSetzeMailAbmeldung,
} from "../hooks/useMailEinstellungen.js";

/** Systemmails ab- und anmelden (#352). Ziel des Links in jeder Systemmail. */
export function BenachrichtigungenPage() {
  const { t } = useTranslation();
  const { user } = useCurrentUser();
  const isAdmin = hasRole(user, "admin");
  const einstellungen = useMailEinstellungen();
  const abmelden = useSetzeMailAbmeldung();
  const erlauben = useSetzeAbmeldenErlaubt();

  return (
    <Stack gap="md">
      <Title order={2}>{t("pages.benachrichtigungen.title")}</Title>
      <Text c="dimmed" size="sm">
        {t("pages.benachrichtigungen.subtitle")}
      </Text>
      {einstellungen.error && <ApiErrorAlert error={einstellungen.error} />}
      {abmelden.error && <ApiErrorAlert error={abmelden.error} />}
      {erlauben.error && <ApiErrorAlert error={erlauben.error} />}
      {einstellungen.data?.map((e) => (
        <Card key={e.art} withBorder>
          <Stack gap="xs">
            <Switch
              checked={!e.abgemeldet || !e.abmeldenErlaubt}
              disabled={!e.abmeldenErlaubt || abmelden.isPending}
              onChange={(ev) =>
                abmelden.mutate({ art: e.art, abgemeldet: !ev.currentTarget.checked })
              }
              label={t(`pages.benachrichtigungen.arten.${e.art}.label`)}
              description={t(`pages.benachrichtigungen.arten.${e.art}.description`)}
            />
            {!e.abmeldenErlaubt && (
              <Alert color="gray" variant="light">
                {t("pages.benachrichtigungen.abmeldenGesperrt")}
              </Alert>
            )}
            {isAdmin && (
              <Group>
                <Switch
                  checked={e.abmeldenErlaubt}
                  disabled={erlauben.isPending}
                  onChange={(ev) =>
                    erlauben.mutate({ art: e.art, abmeldenErlaubt: ev.currentTarget.checked })
                  }
                  label={t("pages.benachrichtigungen.abmeldenErlaubt")}
                  description={t("pages.benachrichtigungen.abmeldenErlaubtHinweis")}
                />
              </Group>
            )}
          </Stack>
        </Card>
      ))}
    </Stack>
  );
}
